import { Component } from 'vue';

class TableComponentLoader {
	public loadInternalEnrolmentsTable(): Promise<Component> {
		return import('@/presentation/components/internal/internal-enrolments-table/internal-enrolments-table.vue');
	}

	public loadGenericEnrolmentsTable(): Promise<Component> {
		return import('@/presentation/components/generalizations/enrolments-table/enrolments-table.vue');
	}

	public loadSuspectedDuplicateDetailsModal(): Promise<Component> {
		return import('@/presentation/components/internal/suspected-duplicate-details-modal/suspected-duplicate-details-modal.vue');
	}
}

export default new TableComponentLoader();
